import { useContent } from "@/context/ContentContext";

const DEFAULT_ERVARINGEN = [
  {
    quote: "René dacht direct mee met onze moeilijke muur in de woonkamer. Het houten wijnrek is een echte blikvanger geworden waar iedereen naar vraagt.",
    naam: "Opdrachtgever Woonproject",
    project: "Maatwerk wijnrek aan stenen muur",
  },
  {
    quote: "De houten kist die René voor ons maakte is van ongekende kwaliteit. Zwaar massief hout, prachtige sluitingen. Dit blijft generaties in de familie.",
    naam: "Particuliere Klant",
    project: "Op maat gemaakte kist met deksel",
  },
  {
    quote: "Prettige communicatie, duidelijke afspraken en een meubelmaker die echt passie heeft voor het vak. Aanrader voor iedereen met een idee op maat.",
    naam: "Interieurstyling Partner",
    project: "Kleinmeubelen & maatwerk project",
  },
];

export const Testimonials = () => {
  const { content } = useContent();
  const ervaringen = content?.testimonials?.length
    ? DEFAULT_ERVARINGEN.map((e, i) => ({ ...e, ...(content.testimonials[i] || {}) }))
    : DEFAULT_ERVARINGEN;

  return (
    <section id="beoordelingen" data-testid="testimonials-section" className="py-24 px-6 max-w-7xl mx-auto">
      <div className="text-center max-w-xl mx-auto mb-16 hr-reveal">
        <span className="text-xs uppercase tracking-widest text-[#9C6D3B] font-bold">Klantvertrouwen</span>
        <h2 className="text-3xl font-normal font-display text-[#2B231D] mt-2">
          Ambacht gebouwd op vertrouwen
        </h2>
        <p className="text-sm text-[#6C5E52] mt-2">
          Persoonlijke aandacht en tevreden opdrachtgevers staan voorop bij elk meubel.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {ervaringen.map((e, i) => (
          <div
            key={i}
            data-testid={`testimonial-card-${i}`}
            className="p-8 rounded-3xl bg-white border border-[#EAE3DA] shadow-sm flex flex-col justify-between hr-reveal"
          >
            <p className="text-sm text-[#594E44] leading-relaxed italic">"{e.quote}"</p>
            <div className="mt-6 pt-6 border-t border-[#F0EBE3]">
              <span className="block text-xs font-bold text-[#2B231D]">{e.naam}</span>
              <span className="block text-[11px] text-[#8C7A6B]">{e.project}</span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
